<template>
  <HbNotice></HbNotice>
</template>

<script lang="ts" setup>
import { HbNotice } from '@hgj/storybrooke-business-tools'
</script>
